module.exports = __webpack_public_path__ + "fonts/Nunito-BlackItalic.d9a8177.ttf";